export default "__VITE_ASSET__3e39465a__"